import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { routeModules } from "./routeModules";

// Home is kept as an eager import since it's the most common landing route.
import Home from "../pages/Home";

// Everything else is code-split with React.lazy, using the shared
// path -> import() list in routeModules.js (see that file for why it's
// factored out — src/index.js reads the same list to pre-warm the current
// page's chunk before hydrating).
const lazyRoutes = routeModules.map(({ path, importFn }) => ({
  path,
  Component: lazy(importFn),
}));

const TheRoutes = () => {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path='/' element={<Home />} />
        {lazyRoutes.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        <Route path='*' element={<Home />} />
      </Routes>
    </Suspense>
  );
};

export default TheRoutes;
